import { createContext, useContext, type ReactNode } from 'react';
import type { CmsAccessState } from '@features/cms/hooks/useCmsAccess.ts';
import type { UserProfile } from '@app-types/user.types.ts';
import type { SiteSettings } from '@store/slices/settingsSlice.tsx';
import type { StaffQuickLink } from './StaffPublicTopbar.tsx';

export interface CmsLegacyStaffContextValue {
  cmsAccess: CmsAccessState;
  profile: UserProfile | null;
  quickLinks: StaffQuickLink[];
  siteSettings: SiteSettings | null;
  userMenu: ReactNode;
  onEnterEditMode: () => void;
  onExitEditMode: () => void;
  editMode: boolean;
}

export const CmsLegacyStaffContext = createContext<CmsLegacyStaffContextValue | null>(null);

export const useCmsLegacyStaff = () => useContext(CmsLegacyStaffContext);

export const CmsLegacySiteSettingsContext = createContext<SiteSettings | null>(null);

export const useCmsLegacySiteSettings = () => useContext(CmsLegacySiteSettingsContext);
